// removed by extract-text-webpack-plugin
module.exports = {"root":"mobileReel__root--dayJw","active":"mobileReel__active--3bDjk","bar":"mobileReel__bar--3uT8B","titleWrapper":"mobileReel__titleWrapper---ona-","title":"mobileReel__title--1A2-H mainTitleText","video":"mobileReel__video--2AC5g","bgvideoWrapper":"mobileReel__bgvideoWrapper--1_Pmn","bgvideo":"mobileReel__bgvideo--21TVK","bgvideoMobile":"mobileReel__bgvideoMobile--3ubPv mobileReel__bgvideo--21TVK","bgvideoDesktop":"mobileReel__bgvideoDesktop--3La16 mobileReel__bgvideo--21TVK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/MobileReel/mobileReel.css
// module id = NU24
// module chunks = 0